<template>
    <div class="mobile-hes">
        <div>
            <el-button type="primary" size="small" v-on:click="showModal = true" :disabled="this.$store.state.user.isProvider">Cargar HES / MIGO</el-button>
        </div>
        <el-dialog title="Cargar datos de operación" :visible.sync="showModal" :append-to-body="true" class="mobile-modal">
            <p style="margin-top: -20px;font-weight: 300;">Datos de la operación</p>
            <el-divider></el-divider>
            <el-form :model="document" ref="formRef" label-width="160px">
                <el-form-item size="small" label="Tipo de operación*" class="form-select">
                    <el-select v-model="document.ocType" placeholder="Tipo de operación">
                    <el-option
                        v-for="item in acceptanceType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                </el-form-item>
                <el-form-item size="small" class="form-input" v-if="document.ocType === '1'">
                    <el-row>
                        <el-col :span="12" :xs="18" class="input-view1-text">
                            Agregar HES
                        </el-col>
                        <el-col :span="12" class="input-view2">
                            <el-button style="margin-left: -10px;" type="warning" @click="addOcNumber">+</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-divider v-if="document.ocType === '1'"></el-divider>
                <el-form-item size="small" class="form-input" v-if="document.ocType === '1'" v-for="(ocNumber, index) in document.hesNumbers" :key="index">
                    <el-row style="margin-bottom: 10px;margin-left: -100px;" :span="24"><b>Carga de HES {{ index+1 }}</b></el-row>
                    <el-row>
                        <el-col :span="12" :xs="20" class="input-view1" style="margin-left:-120px">
                            <el-input class="input-hes__mobile" v-model="document.hesNumbers[index]" placeholder="Numero de HES*"></el-input>
                        </el-col>
                        <el-col :span="12" :xs="24" class="input-view2">
                            <el-button style="margin-left: 35px;" type="warning" @click="deleteOcNumber(index)">-</el-button>
                        </el-col>
                    </el-row>
                  <el-row>
                    <el-row style="margin-bottom: 5px;margin-left: -100px;margin-top:10px" :span="24">Breve descripción*</el-row>
                    <el-form-item>
                    <el-col :span="12" style="margin-left:-120px">
                          <el-input style="width: 400px;" class="description-mobile" v-model="document.hesDescription[index]" placeholder="Breve Descripcion"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item style="margin-left:0%" size="small" label="" class="form-upload" v-if="document.ocType !== ''">
                    <el-col :span="24">
                      <p style="margin-left:-65px;margin-top:10px">Adjuntar Documento</p>
                    </el-col>
                    <el-col style="margin-left:-65px" class="form-pdf">
                    <pdf-file
                    v-bind:pdfFilePath.sync="document.hesFile[index]"
                    :habModificaPdf="habModificaPdf"
                    id="documento"
                  />
                </el-col>
                </el-form-item>
                <el-divider></el-divider>
                <div style="margin-bottom:-20px"/>
              </el-row>
              </el-form-item>
              <el-form-item size="small" class="form-input" v-if="document.ocType === '2'">
                    <el-row>
                        <el-col :span="12" :xs="18" class="input-view1-text">
                            Agregar MIGO
                        </el-col>
                        <el-col :span="12" class="input-view2">
                          <el-button style="margin-left: -10px;" type="warning" @click="addMigoNumber">+</el-button>
                        </el-col>
                      </el-row>
                  </el-form-item>
                  <el-divider v-if="document.ocType === '2'"></el-divider>
                <el-form-item size="small" class="form-input" v-if="document.ocType === '2'" v-for="(ocNumber, index) in document.migoNumbers" :key="index">
                    <el-row style="margin-bottom: 10px;margin-left: -100px;" :span="24"><b>Carga de MIGO {{ index+1 }}</b></el-row>
                    <el-row>
                        <el-col :span="12" :xs="20" class="input-view1" style="margin-left:-120px">
                            <el-input class="input-hes__mobile" v-model="document.migoNumbers[index]" placeholder="Numero de MIGO*"></el-input>
                        </el-col>
                        <el-col :span="12" :xs="24" class="input-view2">
                            <el-button style="margin-left: 35px;" type="warning" @click="deleteMigoNumber(index)">-</el-button>
                        </el-col>
                    </el-row>
                  <el-row>
                    <el-row style="margin-bottom: 5px;margin-left: -100px;margin-top:10px" :span="24">Breve descripción*</el-row>
                    <el-form-item>
                    <el-col :span="12" style="margin-left:-120px">
                          <el-input style="width: 400px;" class="description-mobile" v-model="document.migoDescription[index]" placeholder="Breve Descripcion"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item size="small" label="" class="form-upload" v-if="document.ocType !== ''">
                    <el-col :span="24">
                      <p style="margin-left:-65px;margin-top:10px">Adjuntar Documento</p>
                    </el-col>
                    <el-col style="margin-left:-65px" class="form-pdf">
                    <pdf-file
                    v-bind:pdfFilePath.sync="document.migoFile[index]"
                    :habModificaPdf="habModificaPdf"
                    id="documento"
                    prop="documento"
                  />
                </el-col>
                </el-form-item>
                <el-divider></el-divider>
                <div style="margin-bottom:-20px"/>
              </el-row>
              </el-form-item>
            </el-form>
            <el-divider></el-divider>
            <el-button class="btn" type="primary" size="small" v-on:click="saveOperationData">
                Guardar
            </el-button>
            <el-button class="btn" type="info" v-on:click="showModal = false" size="small">
                Cancelar
            </el-button>
        </el-dialog>
    </div>
  </template>
  
  <script>
  // import api from '../../api'
  import PdfFile from '../PdfFile.vue'
  import api from '../../api'
  
  export default {
    name: 'ButtonGroup',
    components: {
      'pdf-file': PdfFile
    },
    props: {
      idBuyOrder: {
        type: String
      }
    },
    data () {
      return {
        showModal: false,
        document: {
          ocType: '',
          hesNumbers: [],
          hesFile: [],
          migoFile: [],
          migoNumbers: [],
          migoDescription: [],
          hesDescription: [],
          idBuyOrder: this.idBuyOrder
        },
        acceptanceType: [{value: '1', label: 'HES'}, {value: '2', label: 'MIGO'}],
        habModificaPdf: true,
        index: 0
      }
    },
    methods: {
      addOcNumber () {
        this.document.hesNumbers.push('')
        this.document.hesDescription.push('')
        this.document.hesFile.push('')
      },
      deleteOcNumber (index) {
        this.document.hesNumbers.splice(index, 1)
        this.document.hesDescription.splice(index, 1)
        this.document.hesFile.splice(index, 1)
      },
      addMigoNumber () {
        this.document.migoNumbers.push('')
        this.document.migoDescription.push('')
        this.document.migoFile.push('')
      },
      deleteMigoNumber (index) {
        this.document.migoNumbers.splice(index, 1)
        this.document.migoDescription.splice(index, 1)
        this.document.migoFile.splice(index, 1)
      },
      saveOperationData () {
        if ((this.document.ocType === '1' && this.document.hesNumbers.length !== 0 && this.document.hesNumbers[0] !== '' && this.document.hesDescription[0] !== '') || (this.document.ocType === '2' && this.document.migoNumber !== '' && this.document.hesNumbers[0] !== '' && this.document.migoDescription[0] !== '')) {
          api.request('POST', 'api/saveOperationData', this.document)
            .then(response => {
              this.$message.success('Se ha guardado la informacion de la operacion correctamente', 'success')
              this.showModal = false
              this.$router.push('/toBill')
            })
            .catch(error => {
              this.$message.error(error.response.data, 'error')
            })
        } else {
          this.$message.warning('Debe completar los campos obligatorios', 'warning')
        }
      }
    },
    beforeMount () {
    }
  }
  </script>
  <style>
    @media screen and (max-width: 992px) {
      div .el-dialog {
        width: 100%;
      }
      .input-view2 {
        margin-right: 100px;
      }
      .form-select {
        margin-left: 50px;
      }
      .input-hes__mobile {
        margin-left: 50px;
      }
      .description-mobile {
        margin-left: 50px;
      }
      .description-mobile input{
        width: 360px;
      }
    }
    .form-text {
        font-size: 14px;
    }
    .form-input{
        margin-left: -2px;
        width: 100%;
    }
    .form-input input {
        margin-left: 20px;
    }
    .form-select{
        width: 30%;
        margin-left: -25px;
    }
    .form-upload{
        margin-left:-200px;
    }
    .form-pdf{
        margin-left: -150px;
    }
    .input-text{
        margin-left: -152px;
    }
    .input-view1{
        margin-left: -172px;
    }
    .input-view1-text {
        margin-left: -105px;
    }
    @media only screen and (max-width: 1200px) {
    .mobile {
      width: 100%;
    }

    .form-select {
      width: 100%;
    }

    .form-select input {
      width: 60%;
    }

    .form-input {
        width: 100%;
    }

    .form-input input {
        margin-left: -30px;
    }

    .input-view1 {
      margin-left: -120px;
    }

    .input-view2 {
      margin-left: -50px;
    }
  }
  </style>




// WEBPACK FOOTER //
// UploadOrder.vue?09ffea38